/**
 * Frontend assignment status vocabulary. These values are NOT the raw strings
 * the Portal API emits — the assignmentsMapper translates between the two.
 *
 * Portal API strings → enum values:
 *   "in progress" | "pending" | null → TODO
 *   "pending marks"                  → PENDING   (submitted, awaiting mark)
 *   "marked"                         → MARKED
 *   "exempted"                       → EXEMPTED
 *   "resubmission required"          → RESUBMISSION_REQUIRED
 *
 * Note: PENDING represents "submitted, awaiting marks" (Portal "pending marks").
 * Portal also has a separate mid-draft "pending" status — that maps to TODO.
 *
 * The former MARKS_NOT_AVAILABLE value (marked + viewed_at null) was removed.
 * Rules ASG-MARK-4 and ASG-MARK-5 that distinguished read from unread marks
 * are retired in the spec; viewed_at is no longer a gate for any behaviour.
 */
export enum AssignmentStatus {
  TODO = "todo",
  PENDING = "pending",
  MARKED = "marked",
  EXEMPTED = "exempted",
  RESUBMISSION_REQUIRED = "resubmission_required"
}
